import { InformationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface ChatToolStatusProps {
  data: {
    count: number;
    error: string | null;
    tool?: string;
  };
}

export const ChatToolStatus: React.FC<ChatToolStatusProps> = ({ data }) => {
  const isEmpty = data.count === 0 && data.error === null;

  if (isEmpty) {
    return (
      <div className="text-chariot-text-secondary flex items-center gap-2 py-1 text-xs opacity-75">
        <InformationCircleIcon className="size-3" />
        <span>Done</span>
      </div>
    );
  }

  // For non-empty results, show simple info
  return (
    <div className="text-chariot-text-secondary flex items-center gap-2 py-1 text-xs opacity-75">
      <InformationCircleIcon className="size-3" />
      <span>Found {data.count} results</span>
    </div>
  );
};

export default ChatToolStatus;
